export default class ComponentCookies {
    constructor() {
        this.componentCookies = document.querySelector('.component-cookies');

        if(this.componentCookies){
            this.componentCookiesAcceptButton = this.componentCookies.querySelector('.btn-accept-cookies');
            if (typeof this.componentCookies !== 'undefined') {
                this.setEvents();
            }
        }
        
    }

    setEvents() {
        window.addEventListener('DOMContentLoaded', () => {
            if (!this.areCookiesAccepted()) {
                setTimeout(this.showCookiePopup.bind(this), 2000);
            }
        });

        this.componentCookiesAcceptButton.addEventListener('click', this.acceptCookies.bind(this));
    }

    showCookiePopup() {
        this.componentCookies.classList.add('active');
    }

    hideCookiePopup() {
        this.componentCookies.classList.remove('active');
    }

    areCookiesAccepted() {
        let cookies = localStorage.getItem('cookies');
        if (cookies === 'true') {
            return true;
        }

        return false;
    }

    acceptCookies() {
        localStorage.setItem('cookies', 'true');
        this.hideCookiePopup();
    }
}